// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  memId: __t.u64().primaryKey().name("mem_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  warId: __t.u64().name("war_id"),
  inscription: __t.string(),
  fallenJson: __t.string().name("fallen_json"),
  x: __t.f32(),
  z: __t.f32(),
  erectedAt: __t.timestamp().name("erected_at"),
});
